import { createFileRoute } from '@tanstack/react-router';

import { ProductivityPage } from '@/features/siteplan/productivity-page';

export const Route = createFileRoute('/_app/projects/$projectId/workforce/productivity')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <ProductivityPage projectId={projectId} />;
}
